import OutlinedButton from './component.styles'
export default OutlinedButton
